<h2>{{'404.TITLE'|translate}}</h2>
<p>{{'404.PITCH'|translate}}</p>
